const INITIAL_STATE = { registro: {}, modoTela: 'lista', lista: [], listaBrincoTipo: [] };

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'BRINCO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};
        case 'BRINCO_LISTADO':
            return { ...state, modoTela: 'lista', lista: action.payload.data };
		case 'BRINCO_TIPO_SELECT_LISTADO':
            return { ...state, listaBrincoTipo: action.payload.data };
        default:
            return state;
    }
}
